export default "__VITE_ASSET__CdLazEbz__"